import { createSlice } from "@reduxjs/toolkit";

const initialSalesReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  criteria_start_date: null,
  criteria_end_date: null,
  county_criteria_start_date: null,
  county_criteria_end_date: null,
  exportStatus: null,
  catPriceExportStatus: null,
  dayWiseExportStatus: null,
  profitMarginExportStatus: null,
  profitMarginExportUrl: null,
  brandPriceExportStatus: null,
  customerBrandVelocityExportStatus: null,
  purchaseOrderHistoryExportStatus: null,
  customerVelocityReportYearOnYearExportUrl: null,
  customerVelocityReportYearOnYearExportStatus: null,
  saleRepCategoryExportStatus: null,
  saleRepProductExportStatus: null,
  lostSaleExportStatus: null,
  nonPerformanceReportExportStatus: null,
  nonPerformanceReportExportUrl: null,
  saleRepBrandExportStatus: null,
  accountReceivableReportExportStatus: null,
  purchaseReturnHistoryReportExportStatus: null,
  purchaseReturnHistoryReportExportUrl: null,
  inventoryEvaluationReportExportStatus: null,
  itemVelocityWeekOnWeekReportExportStatus: null,
  itemVelocityWeekOnWeekReportExportUrl: null,
  itemVelocityMonthonMonthReportExportStatus: null,
  itemVelocityMonthonMonthReportExportUrl: null,
  californiaCiggerateSalesReportExportStatus: null,
  californiaCiggerateSalesReportExportUrl: null,
  onHoldReportExportStatus: null,
  partiallyFulfilledReportExportStatus: null,
  backOrderReportExportStatus: null,
  invenAdjustExportStatus: null,
  poTaxExportStatus: null,
  calCigExportStatus: null,
  kentuckyReportExportStatus: null,
  indianaTobaccoReportExportStatus: null,
  missouriOtpTaxReportExportStatus: null,
  inventorySpotCheckReportExportStatus: null,
  inventoryLocationReportExportStatus: null,
  damagedMissingExportStatus: null,
  expiryAgingExportStatus: null,
  paymentReceivedReportExportStatus: null,
  SupplierPOExportStatus: null,
  paymentLogReportExportStatus: null,
  accountPayableReportExportStatus: null,
  customerCategoryVelocityExportStatus: null,
  customerCategorySalesExportStatus: null,
  customerProductVelocityExportStatus: null,
  itemVelocityReportStatus: null,
  saleCommissionReportExportStatus: null,
  agingReportExportStatus: null,
  itemDetailExportStatus: null,
  invoiceHistoryExportStatus: null,
  saleSumExportStatus: null,
  postDatedPaymentsReportExportStatus: null,
  postDatedPaymentsReportExportUrl: null,
  driverCollectionReportExportStatus: null,
  driverCollectionReportExportUrl: null,
  preDatedPaymentsReportExportStatus: null,
  preDatedPaymentsReportExportUrl: null,
  customerPerformanceReportExportStatus: null,
  customerPerformanceReportExportUrl: null,
  countyExportStatus: null,
  countyExportUrl: null,
  catPriceExportUrl: null,
  dayWiseExportUrl: null,
  brandPriceExportUrl: null,
  customerBrandVelocityExportUrl: null,
  purchaseOrderHistoryExportUrl: null,
  saleRepCategoryExportUrl: null,
  saleRepProductExportUrl: null,
  lostSaleExportUrl: null,
  saleRepBrandExportUrl: null,
  customerCategoryVelocityExportUrl: null,
  customerCategorySalesExportUrl: null,
  customerProductVelocityExportUrl: null,
  itemVelocityReportExportUrl: null,
  saleCommissionReportExportUrl: null,
  agingReportExportUrl: null,
  accountReceivableReportExportUrl: null,
  inventoryEvaluationReportExportUrl: null,
  onHoldReportExportUrl: null,
  partiallyFulfilledReportExportUrl: null,
  backOrderReportExportUrl: null,
  invenAdjustExportUrl: null,
  poTaxExportUrl: null,
  calCigExportUrl: null,
  kentuckyTobbacoExportUrl: null,
  indianaTobaccoReportExportUrl: null,
  missouriOtpTaxReportExportUrl: null,
  inventorySpotCheckReportExportUrl: null,
  inventoryLocationReportExportUrl: null,
  damagedMissingExportUrl: null,
  expiryAgingExportUrl: null,
  paymentReceivedReportExportUrl: null,
  profitMarginCashBasisExportUrl: null,
  profitMarginCashBasisExportStatus: null,
  SupplierPOExportUrl: null,
  paymentLogReportExportUrl: null,
  accountPayableReportExportUrl: null,
  itemDetailExportUrl: null,
  invoiceHistoryExportUrl: null,
  saleSumExportUrl: null,
  exportURL: null,
  catPriceReportEntities: [],
  brandPriceReportEntities: [],
  paymentReceivedReportEntities: [],
  supplierPOReportEntities: [],
  purchaseReturnHistoryReportEntities: [],
  paymentLogReportEntities: [],
  supplierPaymentLogReportEntities: [],
  itemsDetailReportEntities: [],
  customerBrandVelocityReportEntities: [],
  purchaseOrderHistoryReportEntities: [],
  saleRepCategoryReportEntities: [],
  saleRepProductReportEntities: [],
  lostSaleReportEntities: [],
  nonPerformanceReportEntities: [],
  saleRepBrandReportEntities: [],
  accountReceivableReportEntities: [],
  inventoryEvaluationReportEntities: [],
  onHoldReportEntities: [],
  backOrderReportEntities: [],
  inventorySpotCheckReportEntities: [],
  inventoryLocationReportEntities: [],
  damagedMissingReportEntities: [],
  damagedMissingReportTotalCount: 0,
  expiryAgingReportEntities: [],
  expiryAgingReportTotalCount: 0,
  partiallyFulfilledReportEntities: [],
  accountPayableReportEntities: [],
  customerCategoryVelocityReportEntities: [],
  customerCategorySalesReportEntities: [],
  saleSumReportEntities: [],
  postDatedPaymentsReportEntities: [],
  driverCollectionReportEntities: [],
  driverCollectionReportSummary: {},
  preDatedPaymentsReportEntities: [],
  categoryNames: [],
  taxNames: [],
  purchaseTaxNames: [],
  purchaseTaxPayableNames: [],
  saleCustomCommissionCriteraNames: [],
  saleSummaryDetailsTaxNames: [],
  invoiceHistoryByCustomertaxNames: [],
  saleCommissiontaxNames: [],
  customerProductVelocitytaxNames: [],
  customerProductVelocityReportEntities: [],
  californiaciggerate_sales_reportEntities: [],
  customerVelocityReportYearOnYearEntities: [],
  itemVelocityReportEntities: [],
  itemVelocityMonthOnMonthEntities: [],
  itemVelocityMonthOnMonthTotalCount: 0,
  itemVelocityMonthOnMonth_criteria_start_date: null,
  itemVelocityMonthOnMonth_criteria_end_date: null,
  saleCommissionReportEntities: [],
  agingReportEntities: [],
  countyVelocityReportEntities: [],
  message: {
    error: null,
    success: null,
    modalError: null,
    modalSuccess: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const salesReportSlice = createSlice({
  name: "salesReport",
  initialState: initialSalesReportState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.message.success = null;
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    fetchVelocityReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchInvoiceHistoryReport: (state, action) => {
      const { totalCount, entities, tax_names, criteria_start_date, criteria_end_date } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
      state.invoiceHistoryByCustomertaxNames = tax_names;
      state.criteria_start_date = criteria_start_date;
      state.criteria_end_date = criteria_end_date;
    },
    // fetchcountyVelocityReport: (state, action) => {
    //   const { totalCount, entities } = action.payload;
    //   state.listLoading = false;
    //   state.entities = entities;
    //   state.totalCount = totalCount;
    // },

    fetchCatPriceReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.catPriceReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchBrandPriceReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.brandPriceReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchCustomerBrandVelocityReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.customerBrandVelocityReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchPurchaseOrderHistoryReport: (state, action) => {
      const { totalCount, entities, tax_names, criteria_start_date, criteria_end_date } = action.payload;
      state.listLoading = false;
      state.purchaseOrderHistoryReportEntities = entities;
      state.totalCount = totalCount;
      state.purchaseTaxNames = tax_names;
      state.criteria_start_date = criteria_start_date;
      state.criteria_end_date = criteria_end_date;
    },

    fetchSaleRepCategoryReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.saleRepCategoryReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchSaleRepProductReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.saleRepProductReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchLostSaleReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.lostSaleReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchNonPerformanceReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.nonPerformanceReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchSaleRepBrandReport: (state, action) => {
      const { totalCount, entities, criteria_start_date, criteria_end_date } = action.payload;
      state.listLoading = false;
      state.saleRepBrandReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_start_date = criteria_start_date;
      state.criteria_end_date = criteria_end_date;
    },

    fetchAccountReceivableReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.accountReceivableReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchInventoryEvaluationReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.inventoryEvaluationReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchBackOrderReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.backOrderReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchOnHoldReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.onHoldReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchInventorySpotCheckReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.inventorySpotCheckReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchInventoryLocationReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.inventoryLocationReportEntities = entities;
      state.totalCount = totalCount;
    },

    damagedMissingReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.damagedMissingReportEntities = entities;
      state.damagedMissingReportTotalCount = totalCount;
    },
    expiryAgingReportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.expiryAgingReportEntities = entities;
      state.expiryAgingReportTotalCount = totalCount;
    },

    fetchPartiallyFulfilledReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.partiallyFulfilledReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchPaymentReceivedReport: (state, action) => {
      const { totalCount, entities, criteria_start_date, criteria_end_date } = action.payload;
      state.listLoading = false;
      state.paymentReceivedReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_start_date = criteria_start_date;
      state.criteria_end_date = criteria_end_date;
    },

    fetchSupplierPOReport: (state, action) => {
      const { totalCount, entities, tax_names, tax_payable_names, criteria_start_date, criteria_end_date } = action.payload;
      state.listLoading = false;
      state.supplierPOReportEntities = entities;
      state.totalCount = totalCount;
      state.purchaseTaxNames = tax_names;
      state.purchaseTaxPayableNames = tax_payable_names || [];
      state.criteria_start_date = criteria_start_date;
      state.criteria_end_date = criteria_end_date;
    },

    fetchPaymentLogReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.paymentLogReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchSupplierPaymentLogReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.supplierPaymentLogReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchAccountPayableReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.accountPayableReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchCustomerCategoryVelocityReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.customerCategoryVelocityReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchCustomerCategorySalesReport: (state, action) => {
      const { totalCount, entities, category_names, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.customerCategorySalesReportEntities = entities;
      state.totalCount = totalCount;
      state.categoryNames = category_names;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchCustomerProductVelocityReport: (state, action) => {
      const { totalCount, entities, tax_names, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.customerProductVelocityReportEntities = entities;
      state.totalCount = totalCount;
      state.customerProductVelocitytaxNames = tax_names;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchCustomerPerformanceReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.customerPerformanceReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchCountyVelocityReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.countyVelocityReportEntities = entities;
      state.totalCount = totalCount;
      state.county_criteria_end_date = criteria_end_date;
      state.county_criteria_start_date = criteria_start_date;
    },
    fetchItemVelocityMonthOnMonth: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.itemVelocityMonthOnMonthEntities = entities;
      state.itemVelocityMonthOnMonthTotalCount = totalCount;
      state.itemVelocityMonthOnMonth_criteria_end_date = criteria_end_date;
      state.itemVelocityMonthOnMonth_criteria_start_date = criteria_start_date;
    },
    fetchItemVelocityReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.itemVelocityReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchCaliforniaCiggerateSalesReport: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.californiaciggerate_sales_reportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchCustomerVelocityReportYearOnYear: (state, action) => {
      const { totalCount, entities, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.customerVelocityReportYearOnYearEntities = entities;
      state.totalCount = totalCount;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchSaleCommissionReport: (state, action) => {
      const { totalCount, entities, tax_names, commission_names, criteria_start_date, criteria_end_date } = action.payload;
      state.listLoading = false;
      state.saleCommissionReportEntities = entities;
      state.totalCount = totalCount;
      state.saleCommissiontaxNames = tax_names;
      state.saleCustomCommissionCriteraNames = commission_names;
      state.criteria_start_date = criteria_start_date;
      state.criteria_end_date = criteria_end_date;
    },

    fetchAgingReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.agingReportEntities = entities;
      state.totalCount = totalCount;
    },

    fetchSaleSumReport: (state, action) => {
      const { totalCount, entities, tax_names, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.saleSumReportEntities = entities;
      state.totalCount = totalCount;
      state.taxNames = tax_names;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchPostDatedPaymentsReport: (state, action) => {
      const { totalCount, entities, tax_names, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.postDatedPaymentsReportEntities = entities;
      state.totalCount = totalCount;
      state.taxNames = tax_names;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },
    fetchPreDatedPaymentsReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.preDatedPaymentsReportEntities = entities;
      state.totalCount = totalCount;
    },
    fetchItemsDetailReport: (state, action) => {
      const { totalCount, entities, tax_names, criteria_end_date, criteria_start_date } = action.payload;
      state.listLoading = false;
      state.itemsDetailReportEntities = entities;
      state.totalCount = totalCount;
      state.saleSummaryDetailsTaxNames = tax_names;
      state.criteria_end_date = criteria_end_date;
      state.criteria_start_date = criteria_start_date;
    },

    fetchPurchaseOrderReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    updateStatus: (state, action) => {
      const { status, url } = action.payload;
      state.exportStatus = status;
      state.exportURL = url;
    },

    updateCatPriceStatus: (state, action) => {
      const { status, url } = action.payload;
      state.catPriceExportStatus = status;
      state.catPriceExportUrl = url;
    },

    updateDayWiseStatus: (state, action) => {
      const { status, url } = action.payload;
      state.dayWiseExportStatus = status;
      state.dayWiseExportUrl = url;
    },
    updateProfitMarginReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.profitMarginExportStatus = status;
      state.profitMarginExportUrl = url;
    },
    updateProfitMarginCashBasisReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.profitMarginCashBasisExportStatus = status;
      state.profitMarginCashBasisExportUrl = url;
    },
    updateCountyStatus: (state, action) => {
      const { status, url } = action.payload;
      state.countyExportStatus = status;
      state.countyExportUrl = url;
    },

    updateBrandPriceStatus: (state, action) => {
      const { status, url } = action.payload;
      state.brandPriceExportStatus = status;
      state.brandPriceExportUrl = url;
    },

    updateCustomerBrandVelocityStatus: (state, action) => {
      const { status, url } = action.payload;
      state.customerBrandVelocityExportStatus = status;
      state.customerBrandVelocityExportUrl = url;
    },
    updatePurchaseOrderHistoryStatus: (state, action) => {
      const { status, url } = action.payload;
      state.purchaseOrderHistoryExportStatus = status;
      state.purchaseOrderHistoryExportUrl = url;
    },

    updateSaleRepCategoryStatus: (state, action) => {
      const { status, url } = action.payload;
      state.saleRepCategoryExportStatus = status;
      state.saleRepCategoryExportUrl = url;
    },

    updateSaleRepProductStatus: (state, action) => {
      const { status, url } = action.payload;
      state.saleRepProductExportStatus = status;
      state.saleRepProductExportUrl = url;
    },

    updateLostSaleStatus: (state, action) => {
      const { status, url } = action.payload;
      state.lostSaleExportStatus = status;
      state.lostSaleExportUrl = url;
    },

    nonPerformanceReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.nonPerformanceReportExportStatus = status;
      state.nonPerformanceReportExportUrl = url;
    },
    updateSaleRepBrandStatus: (state, action) => {
      const { status, url } = action.payload;
      state.saleRepBrandExportStatus = status;
      state.saleRepBrandExportUrl = url;
    },

    updateAccountReceivableReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.accountReceivableReportExportStatus = status;
      state.accountReceivableReportExportUrl = url;
    },

    updatePurchaseReturnHistoryReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.purchaseReturnHistoryReportExportStatus = status;
      state.purchaseReturnHistoryReportExportUrl = url;
    },

    updateInventoryEvaluationReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.inventoryEvaluationReportExportStatus = status;
      state.inventoryEvaluationReportExportUrl = url;
    },

    updatePartiallyFulfilledReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.partiallyFulfilledReportExportStatus = status;
      state.partiallyFulfilledReportExportUrl = url;
    },

    updateBackOrderReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.backOrderReportExportStatus = status;
      state.backOrderReportExportUrl = url;
    },
    updateInvenAdjustReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.invenAdjustExportStatus = status;
      state.invenAdjustExportUrl = url;
    },

    updatePoTaxReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.poTaxExportStatus = status;
      state.poTaxExportUrl = url;
    },

    updateCalCigReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.calCigExportStatus = status;
      state.calCigExportUrl = url;
    },

    updateKentuckyTobbacoReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.kentuckyReportExportStatus = status;
      state.kentuckyTobbacoExportUrl = url;
    },

    updateIndianaTobaccoReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.indianaTobaccoReportExportStatus = status;
      state.indianaTobaccoReportExportUrl = url;
    },

    updateMissouriOtpTaxReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.missouriOtpTaxReportExportStatus = status;
      state.missouriOtpTaxReportExportUrl = url;
    },

    updateOnHoldReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.onHoldReportExportStatus = status;
      state.onHoldReportExportUrl = url;
    },

    updateInventorySpotCheckReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.inventorySpotCheckReportExportStatus = status;
      state.inventorySpotCheckReportExportUrl = url;
    },

    updateInventoryLocationReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.inventoryLocationReportExportStatus = status;
      state.inventoryLocationReportExportUrl = url;
    },

    updateDamagedMissingReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.damagedMissingExportStatus = status;
      state.damagedMissingExportUrl = url;
    },
    updateExpiryAgingReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.expiryAgingExportStatus = status;
      state.expiryAgingExportUrl = url;
    },

    updatePaymentReceivedReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.paymentReceivedReportExportStatus = status;
      state.paymentReceivedReportExportUrl = url;
    },

    updateSupplierPOReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.supplierPOReportExportStatus = status;
      state.supplierPOReportExportUrl = url;
    },

    updatePaymentlogReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.paymentLogReportExportStatus = status;
      state.paymentLogReportExportUrl = url;
    },

    updateAccountPayableReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.accountPayableReportExportStatus = status;
      state.accountPayableReportExportUrl = url;
    },

    updateCustomerCategoryVelocityStatus: (state, action) => {
      const { status, url } = action.payload;
      state.customerCategoryVelocityExportStatus = status;
      state.customerCategoryVelocityExportUrl = url;
    },

    updateCustomerCategorySalesStatus: (state, action) => {
      const { status, url } = action.payload;
      state.customerCategorySalesExportStatus = status;
      state.customerCategorySalesExportUrl = url;
    },

    updateCustomerProductVelocityStatus: (state, action) => {
      const { status, url } = action.payload;
      state.customerProductVelocityExportStatus = status;
      state.customerProductVelocityExportUrl = url;
    },

    updateItemVelocityReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.itemVelocityReportStatus = status;
      state.itemVelocityReportExportUrl = url;
    },

    updateSaleCommissionReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.saleCommissionReportExportStatus = status;
      state.saleCommissionReportExportUrl = url;
    },

    updateAgingReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.agingReportExportStatus = status;
      state.agingReportExportUrl = url;
    },

    updateItemDetailStatus: (state, action) => {
      const { status, url } = action.payload;
      state.itemDetailExportStatus = status;
      state.itemDetailExportUrl = url;
    },

    updateInvoiceHistoryStatus: (state, action) => {
      const { status, url } = action.payload;
      state.invoiceHistoryExportStatus = status;
      state.invoiceHistoryExportUrl = url;
    },

    updateSaleSumStatus: (state, action) => {
      const { status, url } = action.payload;
      state.saleSumExportStatus = status;
      state.saleSumExportUrl = url;
    },
    updatePostDatedPaymentsReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.postDatedPaymentsReportExportStatus = status;
      state.postDatedPaymentsReportExportUrl = url;
    },
    fetchDriverCollectionReport: (state, action) => {
      const { totalCount, entities, summary } = action.payload;
      state.listLoading = false;
      state.driverCollectionReportEntities = entities;
      state.driverCollectionReportSummary = summary || {};
      state.totalCount = totalCount;
    },
    updateDriverCollectionReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.driverCollectionReportExportStatus = status;
      state.driverCollectionReportExportUrl = url;
    },
    updatePreDatedPaymentsReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.preDatedPaymentsReportExportStatus = status;
      state.preDatedPaymentsReportExportUrl = url;
    },
    updateCustomerPerformanceReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.customerPerformanceReportExportStatus = status;
      state.customerPerformanceReportExportUrl = url;
    },
    updateCustomerVelocityReportYearOnYearStatus: (state, action) => {
      const { status, url } = action.payload;
      state.customerVelocityReportYearOnYearExportStatus = status;
      state.customerVelocityReportYearOnYearExportUrl = url;
    },
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    updateItemVelocityReportWeekOnWeekStatus: (state, action) => {
      const { status, url } = action.payload;
      state.itemVelocityWeekOnWeekReportExportStatus = status;
      state.itemVelocityWeekOnWeekReportExportUrl = url;
    },
    updateItemVelocityReportMonthOnMonthStatus: (state, action) => {
      const { status, url } = action.payload;
      state.itemVelocityMonthonMonthReportExportStatus = status;
      state.itemVelocityMonthonMonthReportExportUrl = url;
    },
    updateCaliforniaCiggerateSalesReportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.californiaCiggerateSalesReportExportStatus = status;
      state.californiaCiggerateSalesReportExportUrl = url;
    },
    fetchPurchaseReturnHistoryReport: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.purchaseReturnHistoryReportEntities = entities;
      state.totalCount = totalCount;
      state.criteria_start_date = action.payload.criteria_start_date;
      state.criteria_end_date = action.payload.criteria_end_date;
    },
  },
});
